import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const GoldenRings = () => (
  <div className="golden-rings">
    {[...Array(8)].map((_, i) => (
      <motion.div
        key={i}
        className="ring"
        style={{
          left: `${10 + Math.random() * 80}%`,
          top: `${10 + Math.random() * 80}%`,
        }}
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          delay: Math.random() * 2,
        }}
      >
        {'\uD83D\uDC8D'}
      </motion.div>
    ))}
  </div>
);

const ProposalTemplate = ({ question, onYes, showCta, cta, patternStyle = {} }) => {
  if (showCta) {
    return (
      <motion.div
        className="template proposal-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <GoldenRings />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ scale: [1, 1.3, 1], rotate: [0, 5, -5, 0] }}
            transition={{ duration: 1, repeat: Infinity }}
          >
            {'\uD83D\uDC8D'}
          </motion.div>
          <h1>Forever Starts Now!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83D\uDC70\uD83E\uDD35\uD83D\uDC92\uD83D\uDC90\uD83C\uDF8A'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template proposal-template">
      <div className="pattern-overlay" style={patternStyle} />
      <GoldenRings />
      <div className="template-content">
        <motion.div
          className="ring-icon"
          animate={{
            y: [0, -15, 0],
            rotate: [0, 10, -10, 0]
          }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {'\uD83D\uDC8D'}
        </motion.div>

        <motion.h1
          className="invite-question"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {question}
        </motion.h1>

        <div className="button-container">
          <motion.button
            className="yes-button proposal-yes"
            onClick={onYes}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes, Forever! {'\uD83D\uDC8D'}
          </motion.button>
        </div>
      </div>

      <RunawayButton className="proposal-no">
        I need time...
      </RunawayButton>
    </div>
  );
};

export default ProposalTemplate;
